<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2b"><a id="page_9"><span class="txbf">WELCOME TO QO’NOS</span></a></h2><a id="page_9">
<hr class="hr1"/>
<p class="epi"><span class="txit">“Hem tlhIngan Segh ‘ej maHemtaH ‘e’ wIHech.”</span></p>
<p class="epi"><span class="txit">(“Klingons are a proud race, and we intend to go on being proud.”)</span></p>
<p class="att"><span class="txit">—Azetbur, Chancellor to the Klingon High Council, 2293</span></p>
</a><p class="ctoch"><a id="page_9"></a><a href="#/xhtml/ch01aa#ch01lev01">GETTING HERE</a></p>
<p class="ctoch"><a href="#/xhtml/ch01aa#ch01lev02">USING THIS GUIDE</a></p>
<p class="ctoch"><a href="#/xhtml/ch01aa#ch01lev03">TIPS FOR A FUN TRIP</a></p>
<p class="ctoch"><a href="#/xhtml/ch01aa#ch01lev04">WHAT TO WEAR</a></p>
<p class="ctoch"><a href="#/xhtml/ch01aa#ch01lev05">LODGING TIPS</a></p>
<p class="ctoch"><a href="#/xhtml/ch01aa#ch01lev06">ETIQUETTE</a></p>
<p class="ctoch"><span href="#/xhtml/ch01sub01" title="Link target outside of Sample">THE KLINGON EMPIRE: A BRIEF HISTORY FOR VISITORS</span></p>
<p class="ctoc"><span href="#/xhtml/ch01sub01#ch01lev07" title="Link target outside of Sample">Early History, Early Chaos</span></p>
<p class="ctoc"><span href="#/xhtml/ch01sub01#ch01lev08" title="Link target outside of Sample">The Rise of Kahless the Unforgettable</span></p>
<p class="ctoc"><span href="#/xhtml/ch01sub01#ch01lev09" title="Link target outside of Sample">Expansion and Conquest</span></p>
<p class="ctoc"><span href="#/xhtml/ch01sub01#ch01lev10" title="Link target outside of Sample">Contact with Earth and the Federation</span></p>
<p class="ctoc"><span href="#/xhtml/ch01sub01#ch01lev11" title="Link target outside of Sample">The Empire Today</span></p>
<p class="ctoch"><span href="#/xhtml/ch01sub02" title="Link target outside of Sample"><span class="txbfit">tlhIngan Hol!</span> DO YOU SPEAK IT?: A KLINGON LANGUAGE PRIMER</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch01a.vue?23691696